import React from "react"
import { useWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { TextInput } from "shared/ui/input/text/TextInput"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"

export const ProductPositionDisplayPositionInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoading } = useProductPositionFormLoadingContext()
  const { hideDisplayPosition, isDisplayPositionReadonly } = formOptions || {}

  const lvPosition = useWatch({ name: "productPosition.displayPosition" })

  if (
    hideDisplayPosition ||
    !(lvPosition || !(isReadonly || isDisplayPositionReadonly))
  ) {
    return null
  }

  return (
    <TextInput.Root
      name="productPosition.displayPosition"
      label={t("ProductPosition.displayPosition")}
      readonly={isReadonly || isDisplayPositionReadonly}
      loading={isLoading}
      disabled={isDisabled}
      className="product-position-form__display-position"
    >
      <TextInput.Label />
      <TextInput.Focus>
        <TextInput.Input
          type="text"
          data-testid="product-position-form__display-position__input"
        />
        <TextInput.Counter />
      </TextInput.Focus>
      <TextInput.Readonly />
      <TextInput.ErrorMessage />
    </TextInput.Root>
  )
})
